import React, { useState } from "react";
import styles from "./CreateActivity.module.css";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";

import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import ToClose from "../../components/ToClose/ToClose";
import HeadingAndData from "../../components/HeadingAndData/HeadingAndData";
import HeadingAndDropDown from "../../components/HeadingAndDropDown/HeadingAndDropDown";
import Attachment from "../../components/Attachment/Attachment";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";

import { RiPulseLine } from "react-icons/ri";

const CreateActivity = () => {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    name: "",
    color: "",
    file: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileUpload = (file) => {
    setFormData((prev) => ({ ...prev, file }));
  };

  const handleCancel = () => {
    dispatch(closeModal());
  };

  const handleSave = () => {
    console.log("Activity Submitted:", formData);
    dispatch(closeModal());
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <HeadingAndIcon icon={<RiPulseLine />} heading="Create Activity" />
        <ToClose onClose={() => dispatch(closeModal())} />
      </div>
      <div className={styles.content}>
        <div className={styles.form}>
          <HeadingAndData
            label="Activity Name"
            name="name"
            placeholder="Enter Activity Name"
            value={formData.name}
            onChange={handleChange}
            required
          />

          <HeadingAndDropDown
            label="Activity Colour"
            name="color"
            value={formData.color}
            onChange={handleChange}
            options={[
              { label: "Red", value: "red" },
              { label: "Blue", value: "blue" },
              { label: "Green", value: "green" },
            ]}
            required
          />

          <Attachment
            label="Attachment of Video"
            accept="video/*"
            required
            onFileSelect={handleFileUpload}
          />

          <div className={styles.actions}>
            <SaveAndCancel onCancel={handleCancel} onSave={handleSave} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateActivity;
